import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { LAND_USE_PAGE } from './land_use.js';

mountLearnPage(LAND_USE_PAGE);
